module.exports = __webpack_public_path__ + "static/media/geths-mantegna-fixed.bfb0c2a3.jpg";